import React from "react";
import "./Logistics.scss";

const Logistics = ({ title, data }) => {
  const bgImage = data?.background || "/images/industries/key-solutions.webp";

  return (
    <section className="logistics-solutions-section">
      <div className="logistics-container">
        <div className="logistics-header">
          <div className="header-left">
            <span className="subtitle">{title}</span>
            <h2 className="title">Key Solutions</h2>
          </div>
          <div className="header-right">
            <p className="description">
              {data?.description ||
                "We offer a comprehensive suite of services to empower your business to stay ahead in this dynamic industry"}
            </p>
          </div>
        </div>

        <div
          className="solutions-card"
          style={{
            backgroundImage: `url(${bgImage})`,
          }}
        >
          <div className="card-overlay"></div>
          <div className="solutions-grid">
            {data?.cardData?.map((solution, index) => (
              <div key={index} className="solution-item">
                <div className="icon-box">
                  {solution.icon ? (
                    <img src={solution.icon} alt="solution icon" />
                  ) : (
                    <div className="placeholder-icon"></div>
                  )}
                </div>
                <div className="text-box">
                  {solution.title && (
                    <h6 className="solution-title">{solution.title}</h6>
                  )}
                  <p className="solution-text">{solution.description}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default Logistics;
